import "./styles.sass";

import React, { FC, useState, useRef, useEffect } from "react";
import "react-image-crop/dist/ReactCrop.css";
import ReactCrop, { Crop } from "react-image-crop";
import Emptiness from "../UI/emptiness/Emptiness";
import Button from "../UI/button/GgButton";
import Gosa from "../../assets/images/Gosa_avatar.png";
import { AddIcon } from "../../assets/icons";
import { $public } from "../../http";
import { convertFileToBase64, toDataURL } from "../../utils";

export interface IImageLoader {
  onChange: (image: any) => void;
  type?: 1 | 2;
  error?: boolean;
  multi?: boolean;
  value?: string;
  label?: string;
  required?: boolean;
}

const ImageLoader: FC<IImageLoader> = ({
  onChange,
  type,
  error,
  multi = false,
  value,
  label,
  required,
}) => {
  const [isLoop, setLoop] = useState<any>();
  const [fileURL, setURLFile] = useState<any>(null);
  const [crop, setCrop] = useState<Crop>();
  const [proportion, setProportion] = useState<any>(type ? type : 1);
  const [listImage, setListImg] = useState<any>([]);
  const [cropImage, setCropImage] = useState<string>();

  const image = useRef<any>();

  const handleFileChange = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      setURLFile(URL.createObjectURL(e.target?.files[0]));
      try {
        const uploadedImageBase64 = await convertFileToBase64(
          e.target.files[0]
        );
        onChange(uploadedImageBase64);
      } catch (error) {
        console.log("file input error", error);
      }
    }
  };

  function getCroppedImg(dataCrop: Crop) {
    setCrop(dataCrop);
    clearTimeout(isLoop);

    setLoop(
      setTimeout(() => {
        if (typeof crop !== "undefined") {
          const canvas = document.createElement("canvas");
          const scaleX = image.current.naturalWidth / image.current.width;
          const scaleY = image.current.naturalHeight / image.current.height;
          canvas.width = proportion === 1 ? 960 : 1200;
          canvas.height = proportion === 1 ? 960 : 520;
          const ctx = canvas.getContext("2d");

          ctx?.drawImage(
            image.current,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            proportion === 1 ? 960 : 1200,
            proportion === 1 ? 960 : 520
          );
          if (multi) {
            setCropImage(ctx?.canvas.toDataURL("image/jpeg", 0.8) ?? "");
          } else {
            onChange(ctx?.canvas.toDataURL("image/jpeg", 0.8) ?? "");
          }
        }
      }, 500)
    );
  }

  function selectFile() {
    if (!fileURL) {
      document.getElementById("imageInputFile")?.click();
    }
  }

  function turnProportion() {
    if (typeof proportion === "undefined") {
      setProportion(1);
    } else {
      if (proportion === 1) {
        setProportion(1);
      } else {
        setProportion(2.3);
      }
    }
    setCrop(undefined);
  }

  useEffect(() => {
    turnProportion();
    if (value) {
      toDataURL($public(value || ""), function (dataUrl: String) {
        setURLFile(dataUrl);
        onChange(dataUrl);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function save() {
    setListImg([...listImage, cropImage]);
    setURLFile(null);
    setCrop(undefined);
    onChange(listImage ?? "");
  }

  function cancel() {
    setURLFile(null);
    setCrop(undefined);
  }

  function del(indexInList: number) {
    let newListImage = JSON.parse(JSON.stringify(listImage));
    newListImage.splice(indexInList, 1);
    setListImg(newListImage);
  }

  return (
    <div className={`image-loader`}>
      <div className="label">{label}</div>
      <input
        type="file"
        accept="image/*"
        id="imageInputFile"
        className="input-file"
        required={required || false}
        onChange={handleFileChange}
      />
      <div className={`workspace ${error ? "error" : ""}`} onClick={selectFile}>
        {fileURL ? (
          <>
            <ReactCrop crop={crop} aspect={proportion} onChange={getCroppedImg}>
              <img
                ref={image}
                src={fileURL}
                alt="original"
                className="original"
              />
            </ReactCrop>
            <div
              onClick={() => {
                document.getElementById(`imageInputFile`)?.click();
                setCrop(undefined);
              }}
              className="edit-icon"
            >
              <img
                src={require("../../assets/images/edit.png")}
                alt="edit"
                style={{
                  maxWidth: "1.2rem",
                  height: "1.2rem",
                }}
              />
            </div>
          </>
        ) : (
          <div
            className="add-image"
            style={{ display: "flex", width: "100%", justifyContent: "center" }}
          >
            <Emptiness icon={Gosa} />
            <Button
              label="Add image"
              icon={{ leftIcon: <AddIcon size="18" className="icon" /> }}
              stylesType="border"
            />
          </div>
        )}
      </div>
      {/* <div className="toolContainer">
        <div className="tools">
          {multi && (
            <Button disabled={!fileURL} className="tool-item" stylesType="success" label="Сохранить" onPress={save} />
          )}
          <Button disabled={!fileURL} className="tool-item" stylesType="delete" label="Отмена" onPress={cancel} />
          {!type && (
            <Button className="tool-item" label={proportion === 1 ? 'Квадрат' : 'Прямоугольник'} onPress={turnProportion} />
          )}
        </div>
        {multi && (
          <div className="containerListImage">
            <div className="listImg">
              {listImage.map((item: string, index: number) => (
                <div key={`image-list-${index}`} className="itemImage">
                  <div className="delete"><FontAwesomeIcon icon="close" onClick={() => del(index)} /></div>
                  <img src={item} alt="" />
                </div>
              ))}
              <div className={`itemImageAdd ${fileURL && "disabled"}`} onClick={() => selectFile()}>
                <FontAwesomeIcon icon="plus" />
              </div>
            </div>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default ImageLoader;
